<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_COMPANY)">
        <router-link :to="companiesLink" class="nav-link">
          <i class="fa fa-building mr-1"/>Companies
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_COMPANY)">
        <router-link :to="contactsLink" class="nav-link">
          <i class="fa fa-address-book mr-1"/>Contacts
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_COMPANY)">
        <router-link :to="tasksLink" class="nav-link">
          <i class="fa fa-tasks mr-1"/>Tasks
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    metaInfo: () => ({
      title: 'New Erp',
    }),
    data() {
      return {};
    },
    computed: {
      ...mapGetters('contactCenter', ['lastOpenedTab',
        'companiesLink',
        'tasksLink',
        'contactsLink',
      ]),
    },
    methods: {
      ...mapMutations('contactCenter', ['setItem']),
    },
    watch: {},
    mounted() {
      if (!this.lastOpenedTab) {
        this.setItem({ resource: 'companiesLink', payload: this.companiesLink });
        this.setItem({ resource: 'lastOpenedTab', payload: this.companiesLink });
      }
      if (this.$route.meta.controlLink) {
        this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
        this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
      }
    },
  };
</script>

<style scoped>
.new-offer-button {
  right: 10px;
  position: absolute;
  top: 4px;
}
</style>
